import React from 'react';
import { ChecklistItem } from '@frontend/Models/Checklist';

interface DCItemProps {
  item: ChecklistItem;
}

export const DCItem: React.FC<DCItemProps> = ({ item }) => {
  const title = item.description || 'N/A';

  const status = item.status ? 'Active' : 'Inactive';

  return (
    <div className="matter-checklist-item">
      <div className="matter-checklist-title">{title}</div>
      <div className="matter-checklist-meta">
        <span>Status: {status}</span>
        {item.matterid && (
          <span className="matter-checklist-assigned">
            ID: {item.matterid}
          </span>
        )}
      </div>
    </div>
  );
};
